import script from "./InputPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./InputPassword.vue?vue&type=script&setup=true&lang=js"

import "./InputPassword.vue?vue&type=style&index=0&id=08fe4a6b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fe4a6b"]])

export default __exports__